import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { de } from 'vuetify/locale'

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'de',
    messages: { de },
  },
  icons: {
    defaultSet: 'mdi',
  },
  defaults: {
    // V2 default for inputs was underlined (single bottom border), not outlined
    VTextField: {variant: 'underlined' },
    VSelect: {  variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
    VCombobox: { variant: 'underlined' },
    VTextarea: {  variant: 'underlined' },
    VFileInput: { variant: 'underlined' },

    // V2 default for buttons was elevated; V3 changes this to 'text' inside VCardActions
    VBtn: { variant: 'elevated' },
    // Override VCardActions context which would otherwise force variant='text' on child buttons
    VCardActions: {
      VBtn: { variant: 'elevated' },
    },
    VDataTable: {
      VSelect: { variant: 'underlined' },
    },
    VDataTableServer: {
      VSelect: { variant: 'underlined' },
    },
// FIXME: remove or not, thats the questions!
    // // V2 default for inputs was underlined (single bottom border), not outlined
    // VTextField: { density: 'compact', variant: 'underlined' },
    // VSelect: { density: 'compact', variant: 'underlined' },
    // VAutocomplete: { density: 'compact', variant: 'underlined' },
    // VCombobox: { density: 'compact', variant: 'underlined' },
    // VTextarea: { density: 'compact', variant: 'underlined' },
    // VFileInput: { density: 'compact', variant: 'underlined' },
    // VCheckbox: { density: 'compact' },
    // VRadio: { density: 'compact' },
    // VSwitch: { density: 'compact' },
    // // V2 default for buttons was elevated; V3 changes this to 'text' inside VCardActions
    // VBtn: { variant: 'elevated' },
    // // Override VCardActions context which would otherwise force variant='text' on child buttons
    // VCardActions: {
    //   VBtn: { variant: 'elevated' },
    // },
    // VDataTable: { density: 'compact' },
    // VList: { density: 'compact' },
  },
})

